import React from "react";
import { Link, useLocation } from "react-router-dom";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Select from "react-select";
import { compaignData } from "../../core/data/json/campaignData";
import Table from "../../core/common/dataTable/index";
import { TableData } from "../../core/data/interface";
import { all_routes } from "../router/all_routes";
import { useDispatch, useSelector } from "react-redux";
import CollapseHeader from "../../core/common/collapse-header";
import CampaignModal from "../../core/modals/campaign_modal";
import ImageWithBasePath from "../../core/common/imageWithBasePath";

const CampaignComplete = () => {
  const route = all_routes;
  const data = compaignData;
  const dispatch = useDispatch();
  const activityToggleTwo = useSelector(
    (state: any) => state?.activityTogglePopupTwo
  );
  const campaignType = [
    { value: "choose", label: "Choose" },
    { value: "public_relations", label: "Public Relations" },
    { value: "brand", label: "Brand" },
    { value: "media", label: "Media" },
  ];
  const currency = [
    { value: "Choose", label: "Choose" },
    { value: "Dollar", label: "Dollar" },
    { value: "Euro", label: "Euro" },
    { value: "Pound", label: "Pound" },
    { value: "Rupee", label: "Rupee" },
  ];
  const targeyAudience = [
    { value: "small_business", label: "Small Business" },
    { value: "corporate_companies", label: "Corporate Companies" },
    { value: "urban_apartment", label: "Urban Apartment" },
    { value: "business", label: "Business" },
  ];

  const filterSelect = [
    { value: "default", label: "Select a View" },
    { value: "contactViewList", label: "Contact View List" },
    { value: "contactLocationView", label: "Contact Location View" },
  ];
  const location = useLocation();
  const isLinkActive = (route: string) => {
    // Check if the current location matches the given route
    return location.pathname === route;
  };
  const initialSettings = {
    endDate: new Date("2020-08-11T12:30:00.000Z"),
    ranges: {
      "Last 30 Days": [
        new Date("2020-07-12T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      "Last 7 Days": [
        new Date("2020-08-04T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      "Last Month": [
        new Date("2020-06-30T18:30:00.000Z"),
        new Date("2020-07-31T18:29:59.999Z"),
      ],
      "This Month": [
        new Date("2020-07-31T18:30:00.000Z"),
        new Date("2020-08-31T18:29:59.999Z"),
      ],
      Today: [
        new Date("2020-08-10T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      Yesterday: [
        new Date("2020-08-09T04:57:17.076Z"),
        new Date("2020-08-09T04:57:17.076Z"),
      ],
    },
    startDate: new Date("2020-08-04T04:57:17.076Z"), // Set "Last 7 Days" as default
    timePicker: false,
  };
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a: TableData, b: TableData) => a.name.length - b.name.length,
    },
    {
      title: "Call Time",
      dataIndex: "call_time",
      sorter: (a: TableData, b: TableData) => a.type.length - b.type.length,
    },
    {
      title: "List Associated",
      dataIndex: "list_associated",
      sorter: (a: TableData, b: TableData) => a.type.length - b.type.length,
    },
    {
      title: "Dialled Leads/Total Leads",
      dataIndex: "total_lead",
      sorter: (a: TableData, b: TableData) => a.type.length - b.type.length,
    },
  
    {
      title: "Hopper Count",
      dataIndex: "hopper_count",
      
    },
    {
      title: "Hopper Mode",
      dataIndex: "hopper_mode",
      render: (text: string) => (
        <div>
          {text === "Linear" && (
            <span className="badge badge-pill badge-status bg-success">
              {text}
            </span>
          )}
          {text === "Random" && (
            <span className="badge badge-pill badge-status bg-danger">
              {text}
            </span>
          )}
         
        </div>
      ),
      sorter: true,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string) => (
        <div>
          {text === "on" && (
            <span className="badge badge-pill badge-status bg-success">
              {text}
            </span>
          )}
         
          {text === "off" && (
            <span className="badge badge-pill badge-status bg-danger">
              {text}
            </span>
          )}
         
        </div>
      ),
      sorter: true,
    },

    {
      title: "Created",
      dataIndex: "created",
      sorter: (a: TableData, b: TableData) =>
        a.created.length - b.created.length,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: () => (
        <div className="dropdown table-action">
          <Link
            to="#"
            className="action-icon"
            data-bs-toggle="dropdown"
            aria-expanded="true"
          >
            <i className="fa fa-ellipsis-v"></i>
          </Link>
          <div
            className="dropdown-menu dropdown-menu-right"
            style={{
              position: "absolute",
              inset: "0px auto auto 0px",
              margin: "0px",
              transform: "translate3d(-99.3333px, 35.3333px, 0px)",
            }}
            data-popper-placement="bottom-start"
          >
           <Link className="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvas_edit" to="#"><i className="ti ti-edit text-blue"></i> Edit</Link>
            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete_campaign"
            >
              <i className="ti ti-trash text-danger"></i> Delete
            </Link>
          </div>
        </div>
      ),
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-4">
                    <h4 className="page-title">
                      Campaign<span className="count-title">123</span>
                    </h4>
                  </div>
                  <div className="col-8 text-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
             
              {/* Campaign Tab */}
              <div className="campaign-tab">
                <ul className="nav">
                  <li>
                    <Link
                      to={route.campaign}
                      className={isLinkActive(route.campaign) ? "active" : ""}
                    >
                      Agent Status<span>24</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={route.campaignComplete}
                      className={
                        isLinkActive(route.campaignComplete) ? "active" : ""
                      }
                    >
                      Campaign List
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={route.campaignArchieve}
                      className={
                        isLinkActive(route.campaignArchieve) ? "active" : ""
                      }
                    >
                      Campaign Disposition
                    </Link>
                  </li>
                </ul>
              </div>
              {/* Campaign Tab */}
              <div className="card">
                <div className="card-header">
                  {/* Search */}
                  <div className="row align-items-center">
                    <div className="col-sm-4">
                      <div className="icon-form mb-3 mb-sm-0">
                        <span className="form-icon">
                          <i className="ti ti-search" />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search Campaign"
                        />
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                        <div className="dropdown me-2">
                          <Link
                            to="#"
                            className="dropdown-toggle"
                            data-bs-toggle="dropdown"
                          >
                            <i className="ti ti-package-export me-2" />
                            Export
                          </Link>
                          <div className="dropdown-menu  dropdown-menu-end">
                            <ul>
                              <li>
                                <Link
                                  to="#"
                                  className="dropdown-item"
                                >
                                  <i className="ti ti-file-type-pdf text-danger me-1" />
                                  Export as PDF
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="#"
                                  className="dropdown-item"
                                >
                                  <i className="ti ti-file-type-xls text-green me-1" />
                                  Export as Excel{" "}
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <Link
                          to="#"
                          className="btn btn-primary"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvas_add"
                        >
                          <i className="ti ti-square-rounded-plus me-2" />
                          Add New Campaign
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* /Search */}
                </div>

                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                      <div className="dropdown me-2">
                        <Link
                          to="#"
                          className="dropdown-toggle"
                          data-bs-toggle="dropdown"
                        >
                          <i className="ti ti-sort-ascending-2 me-2" />
                          Sort{" "}
                        </Link>
                        <div className="dropdown-menu  dropdown-menu-start">
                          <ul>
                            <li>
                              <Link
                                to="#"
                                className="dropdown-item"
                              >
                                <i className="ti ti-circle-chevron-right me-1" />
                                Ascending
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="#"
                                className="dropdown-item"
                              >
                                <i className="ti ti-circle-chevron-right me-1" />
                                Descending
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="#"
                                className="dropdown-item"
                              >
                                <i className="ti ti-circle-chevron-right me-1" />
                                Recently Viewed
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="#"
                                className="dropdown-item"
                              >
                                <i className="ti ti-circle-chevron-right me-1" />
                                Recently Added
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="icon-form">
                        <span className="form-icon">
                          <i className="ti ti-calendar" />
                        </span>
                        <DateRangePicker initialSettings={initialSettings}>
                          <input
                            className="form-control bookingrange"
                            type="text"
                          />
                        </DateRangePicker>
                      </div>
                    </div>
                   
                  </div>

                  {/* Campaign List */}
                  <div className="table-responsive custom-table">
                    <Table dataSource={data} columns={columns} />
                  </div>
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <div className="datatable-length" />
                    </div>
                    <div className="col-md-6">
                      <div className="datatable-paginate" />
                    </div>
                  </div>
                  {/* /Campaign List */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <CampaignModal />

      </div>
        {/* Edit Campaign */}
        <div
          className="offcanvas"
          style={{ width: "1150px", right: "0", top: "0" }}
          tabIndex={-1}
          id="offcanvas_edit"
        >
          <div className="offcanvas-header border-bottom">
            <h4>Edit Campaign</h4>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="offcanvas-body">
            <form>
              <div>
                <div className="row">
                  <div className="mb-3 col-md-6">
                    <label className="col-form-label">
                      Name <span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="mb-3 col-md-6 ">
                    <label className="col-form-label">
                      Description <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control"
                      rows={1}
                      defaultValue={""}
                    />
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="col-form-label">
                      Campaign Type <span className="text-danger">*</span>
                    </label>
                    <Select
                      options={campaignType}
                      className="select"
                      placeholder="Choose"
                      classNamePrefix="react-select"
                    />
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Call Time </label>
                    <div>
                      <div className="input-group">
                        <span className="input-group-text ">
                          <i className="ti-user"></i>
                        </span>

                        <input
                          type="time"
                          className="form-select"
                          value="09:30"
                          name="call_time_start"
                          id="timepicker"
                        />
                        <span className="input-group-addon bg-primary text-white b-1 p-2">
                          to
                        </span>
                        <input
                          type="time"
                          className="form-select"
                          value="21:30"
                          name="call_time_end"
                          id="timepicker3"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Country Code </label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        className="form-select"
                        name="country_code"
                        id="country_code"
                      >
                        <option value="1">
                          United States &amp; Canada (+1)
                        </option>
                        <option value="44">United Kingdom (+44)</option>
                        <option value="90">Turkey (+90)</option>
                        <option value="41">Switzerland (+41)</option>
                        <option value="46">Sweden (+46)</option>
                        <option value="34">Spain (+34)</option>
                        <option value="27">South Africa (+27)</option>
                        <option value="64">New Zealand (+64)</option>
                        <option value="599">Netherlands Antilles (+599)</option>
                        <option value="39">Italy (+39)</option>
                        <option value="353">Ireland (+353)</option>
                        <option value="852">Hong Kong S.A.R. (+852)</option>
                        <option value="49">Germany (+49)</option>
                        <option value="33">France (+33)</option>
                        <option value="45">Denmark (+45)</option>
                        <option value="55">Brazil (+55)</option>
                        <option value="32">Belgium (+32)</option>
                        <option value="43">Austria (+43)</option>
                        <option value="61">Australia (+61)</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6" id="show_predictive">
                    <label className="form-label">Dialing Mode </label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>
                      <select
                        name="dial_mode"
                        className="form-select"
                        id="dial-mode"
                      >
                        <option value="super_power_dial">
                          Super Power Dial
                        </option>
                        <option value="outbound_ai">Outbound AI</option>
                      </select>
                    </div>
                  </div>
                  <div className=" mb-3 col-md-6">
                    <label className="form-label">Caller Group </label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        name="group_id"
                        className="form-select"
                        id="group_id"
                      >
                        <option value="1">India Agents</option>

                        <option value="2">India Manager</option>

                        <option value="22">Testing</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Caller Id </label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        name="caller_id"
                        className="form-select"
                        id="caller_id"
                      >
                        <option value="custom">Custom</option>
                        <option value="area_code">Area Code</option>
                        <option value="area_code_random">
                          AreaCode And Randomizer
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Custom Caller Id </label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        className="form-select"
                        name="custom_caller_id"
                        value=""
                        id="custom-caller-id"
                      >
                        <option value="">Select DID</option>
                        <option data-cnam="test" value="14753159039">
                          14753159039 -test -IVR
                        </option>
                        <option data-cnam="" value="9155335759">
                          9155335759
                        </option>
                        <option data-cnam="" value="9155335769">
                          9155335769
                        </option>
                        <option data-cnam="" value="9155335779">
                          9155335779
                        </option>
                        <option data-cnam="" value="9155335789">
                          9155335789
                        </option>
                        <option data-cnam="Gaurav" value="19028024445">
                          19028024445 -Gaurav -Extension -ab cd - 32222
                        </option>
                        <option data-cnam="Rohit India" value="19027104845">
                          19027104845 -Rohit India -DID +917756966016
                        </option>
                        <option data-cnam="Mr. Lube" value="19024255823">
                          19024255823 -Mr. Lube -IVR
                        </option>
                        <option data-cnam="Raj forwarding" value="15162125295">
                          15162125295 -Raj forwarding -DID +917756966016
                        </option>
                        <option data-cnam="Rohit Canada" value="19029054776">
                          19029054776 -Rohit Canada -DID +917756966016
                        </option>
                        <option data-cnam="Rohit" value="19024412385">
                          19024412385 -Rohit -IVR
                        </option>
                        <option data-cnam="Telnyx Test" value="15166361512">
                          15166361512 -Telnyx Test -Extension
                        </option>
                        <option data-cnam="AI Demo" value="19034377388">
                          19034377388 -AI Demo -Extension
                        </option>
                        <option data-cnam="SunPrint CA" value="19027066999">
                          19027066999 -SunPrint CA -IVR
                        </option>
                        <option data-cnam="Twinning Test" value="13109191294">
                          13109191294 -Twinning Test -Extension -ab cd - 32222
                        </option>
                        <option data-cnam="India" value="16312030323">
                          16312030323 -India -IVR
                        </option>
                        <option data-cnam="Voice blastin" value="16315950959">
                          16315950959 -Voice blastin -IVR
                        </option>
                        <option data-cnam="Rohit Canada" value="15162000091">
                          15162000091 -Rohit Canada -DID +918492042715
                        </option>
                        <option data-cnam="Ashish Odbond" value="16312405683">
                          16312405683 -Ashish Odbond -DID +919896635987
                        </option>
                        <option data-cnam="Shubham" value="16479321367">
                          16479321367 -Shubham -Extension
                        </option>
                        <option data-cnam="Rohit test" value="15168995395">
                          15168995395 -Rohit test -DID 917756966016
                        </option>
                        <option data-cnam="Rohit Wanchoo" value="16313362141">
                          16313362141 -Rohit Wanchoo -Extension -Test Demo App -
                          36706
                        </option>
                        <option data-cnam="Company" value="15168815865">
                          15168815865 -Company -Extension
                        </option>
                        <option data-cnam="Developer Tes" value="16139004832">
                          16139004832 -Developer Tes -DID +919818002784
                        </option>
                        <option data-cnam="Abhishek" value="15168868507">
                          15168868507 -Abhishek -Extension -vj webtrc test -
                          32170
                        </option>
                        <option data-cnam="BuzzClicker" value="18446142007">
                          18446142007 -BuzzClicker -DID 19024412385
                        </option>
                        <option data-cnam="VoIP" value="18882711420">
                          18882711420 -VoIP -DID 16466230005
                        </option>
                        <option data-cnam="Rohit" value="16318176316">
                          16318176316 -Rohit -Extension
                        </option>
                        <option data-cnam="Fax" value="16465533256">
                          16465533256 -Fax -Extension
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6" id="show_predictive_status">
                    <label className="form-label">Status </label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>
                      <select name="status" className="form-select" id="status">
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Time Based Calling </label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        name="time_based_calling"
                        className="form-select"
                        id="time_based_calling"
                      >
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Send Email </label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select name="email" className="form-select" id="email">
                        <option value="0">No</option>
                        <option value="1">With User Email</option>
                        <option value="2">With Campaign Email</option>
                        <option value="3">With System Email</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Send SMS</label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select name="sms" className="form-select" id="sms">
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Send Report</label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        name="send_report"
                        className="form-select"
                        id="campaign_send_report"
                      >
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </select>
                    </div>
                  </div>
                  <div className=" mb-3 col-md-6">
                    <label className="form-label">Call Transfer</label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        name="call_transfer"
                        className="form-select"
                        id="call_transfer"
                      >
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Hopper Mode Type </label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        name="hopper_mode"
                        className="form-select"
                        id="hopper_mode"
                      >
                        <option value="1">Linear</option>
                        <option value="2">Random</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6 ">
                    <label className="col-form-label">
                      Disposition <span className="text-danger">*</span>
                    </label>
                    <Select
                      defaultValue={[
                        targeyAudience[1],
                        targeyAudience[2],
                        targeyAudience[3],
                      ]}
                      isMulti
                      name="colors"
                      options={targeyAudience}
                      className="select"
                    />
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Outbound Line </label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        className="form-select"
                        name="voip_configurations"
                        data-placeholder="Select Disposition"
                      >
                        <option value="">Select VOIP</option>
                        <option value="2">Didfrosale</option>
                        <option value="5">Voxox Inbound</option>
                        <option value="6">1009071435</option>
                        <option value="7">1001768509</option>
                        <option value="8">Test-1_3_1515</option>
                        <option value="9">Signal-Wire_3_1595</option>;
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  data-bs-dismiss="offcanvas"
                  className="btn btn-light me-2"
                >
                  Cancel
                </button>
                <button type="button" className="btn btn-primary">
                 Update
                </button>
              </div>
            </form>
          </div>
        </div>
        {/* /Edit Campaign */}
    
      
        {/* Delete Campaign */}
        <div className="modal fade" id="delete_campaign" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div className="text-center">
                  <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                    <i className="ti ti-trash-x fs-36 text-danger" />
                  </div>
                  <h4 className="mb-2">Remove campaign?</h4>
                  <p className="mb-0">
                    Are you sure you want to remove <br /> campaign you
                    selected.
                  </p>
                  <div className="d-flex align-items-center justify-content-center mt-4">
                    <Link
                      to="#"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      className="btn btn-danger"
                      data-bs-dismiss="modal"
                    >
                      Yes, Delete it
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Delete Campaign */}
      {/* /Page Wrapper */}
    </>
  );
};

export default CampaignComplete;
